// eslint-disable-next-line
import React from 'react';
import { Button } from '@material-ui/core';

import { ModalIDs } from 'redux/reducers/gl_modal_reducer/types';

import { useDispatch } from 'react-redux';
import ModalActions from 'redux/reducers/gl_modal_reducer/actions';
// import { useModalData } from 'redux/reducers/gl_modal_reducer/selectors';
import BaseModal from 'components/molecules/base_modal';

export interface IFormData {}

export const defaultValues: IFormData = {};

export interface IConfirmationModalProps {
  title?: (params?: any) => React.ReactElement;
  body?: (params?: any) => React.ReactElement;
  modalID?: ModalIDs;
  confirmButton?: string;
  cancelButton?: string;
  onClose?: (response: boolean, params: any) => void;
}

const ConfirmationModal = (props: IConfirmationModalProps) => {
  const {
    title,
    body,
    modalID = ModalIDs.CONFIRMATION_MODAL,
    confirmButton = 'Confirm',
    cancelButton = 'Cancel',
    onClose,
  } = props;
  const dispatch = useDispatch();

  return (
    <BaseModal
      modalID={modalID}
      renderHeader={(params) => {
        return title ? (
          <React.Fragment>{title(params)}</React.Fragment>
        ) : (
          <React.Fragment>Confirmation</React.Fragment>
        );
      }}
      renderContent={(params) => {
        return body ? (
          <React.Fragment>{body(params)}</React.Fragment>
        ) : (
          <React.Fragment>
            Are you sure you want to do that action?
          </React.Fragment>
        );
      }}
      renderFooter={(params) => {
        return (
          <React.Fragment>
            <Button
              variant="contained"
              color="primary"
              onClick={async () => {
                onClose && onClose(true, params);
                dispatch(
                  ModalActions.closeModalAction({
                    modalID: modalID,
                  })
                );
              }}
            >
              {confirmButton}
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                onClose && onClose(false, params);
                dispatch(
                  ModalActions.closeModalAction({
                    modalID: modalID,
                  })
                );
              }}
            >
              {cancelButton}
            </Button>
          </React.Fragment>
        );
      }}
    />
  );
};

export default React.memo(ConfirmationModal);
